import TrackingService from '../services/TrackingService';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    CART_DATA_VARIABLE: 'js_userCart',
    ORDER_DATA_VARIABLE: 'js_orderInformation',
    PRODUCT_DETAIL_LINK: 'js-orderConfirmation',
};

const PATHS = {
    ADD_PAYMENT_INFO: '/checkout/payment/add-payment',
    ADD_SHIPPING_INFO: '/checkout/delivery-address/add-address',
    ORDER_CONFIRMATION: '/checkout/summary'
};

/**
 * 
 * @constructor
 */
export default class CheckoutTracking {
    constructor($element) {
        this.$element = $element;
        this.cartData = window[SELECTORS.CART_DATA_VARIABLE];
        this.orderData = window[SELECTORS.ORDER_DATA_VARIABLE];
        this.trackingService = new TrackingService();

        return this.checkPageTracking();
    }


    checkPageTracking(){
        // check page urls - need specific events for the following:
        // add_payment_info -> /checkout/payment/add-payment
        // add_shipping_info -> /checkout/delivery-address/add-address
        // purchase -> /checkout/summary (order-specific information)
        var curPagePath = window.location.pathname;
        if(curPagePath.indexOf(PATHS.ADD_PAYMENT_INFO) > -1){
            this.trackingService.addPaymentInfo(this.cartData);
        }
        if(curPagePath.indexOf(PATHS.ADD_SHIPPING_INFO) > -1){
            this.trackingService.addShippingInfo(this.cartData);
        }
        if(curPagePath.indexOf(PATHS.ORDER_CONFIRMATION) > -1){
            this.trackingService.purchase(this.orderData);
            this.trackingService.adsConversion(this.orderData, "AW-830898396/ThLpCNeIk-sYENyBmowD");
        }
        return this;
    }


}